<template>
    <AdminPanelYoutvPackageSellingHistoryEdit />
   </template>
   
   <script>
   import AdminPanelYoutvPackageSellingHistoryEdit  from '../components/AdminPanelYoutvPackageSellingHistoryEdit.vue'
   export default {
       data: () => ({}),
       components: {
           AdminPanelYoutvPackageSellingHistoryEdit
       },
       methods: {},
       mounted() {}
   }
   </script>
   